import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import "./i18n"
import reportWebVitals from "./reportWebVitals"
import { BrowserRouter, HashRouter } from "react-router-dom"
import ScrollToTop from "./components/common/ScrollToTop"
import { ChakraProvider } from "@chakra-ui/react"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
	<React.StrictMode>
		<BrowserRouter basename="">
			<ScrollToTop />
			{/* <ChakraProvider> */}

			<App />
			{/* </ChakraProvider> */}
		</BrowserRouter>
	</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
